
import {
  ref,
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
} from "vue";
import {
  technologicalFrontierData,
  getArticleByCategoryId,
  getBannerByPosition,
} from "../views/api/user";
export default defineComponent({
  setup() {
    //获取全局变量
    const proxy = getCurrentInstance() as any;
    console.log("proxy11", proxy);
    //全局url
    const url = proxy.appContext.config.globalProperties.$url;
    let type = ref(false);
    let internationalCooperationData = ref([]);
    let show = ref<any>(true);
    //全局语言
    if (window.sessionStorage.getItem("language") as string) {
      var lan = JSON.parse(proxy.appContext.config.globalProperties.$language);
    }
    if (lan == "EN") {
      show.value = false;
    } else {
      show.value = true;
    }
        // chrome
      document.body.scrollTop = 0;
      // firefox
      document.documentElement.scrollTop = 0;
    //获取国际合作数据
    const internationalCooperation = async () => {
      if (lan == "EN") {
 const column = reactive({
        categoryId: 289547676836165,
      });
      const res = await getArticleByCategoryId.getData(column);
      internationalCooperationData.value = res.data.result;
      console.log("internationalCooperationData", internationalCooperationData);

      } else {
 const column = reactive({
        categoryId: 279283652706629,
      });
      const res = await getArticleByCategoryId.getData(column);
      internationalCooperationData.value = res.data.result;
      console.log("internationalCooperationData", internationalCooperationData);

      }

     
    };

    const show1 = () => {
      type.value = !type.value;
    };

    onMounted(() => {
      internationalCooperation();
    });

    return {
      url,
      internationalCooperation,
      show1,
      show,
      internationalCooperationData,
      type,
    };
  },
});
